import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { HazardFormListFilterComponent } from '../hazard-form-filter/hazard-form-filter.component';
import { SubmittedFormListFilterComponent } from '../submitted-form-filter/submitted-form-filter.component';
import { SubmittedFormListService } from './submitted-forms-list.service';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { SubmittedFormPreviewService } from '../submitted-form-preview/submitted-form-preview.service';
import { Location } from "@angular/common";
import { SubmittedFormFilterService } from '../submitted-form-filter/submitted-form-filter.service';
import { AssignUsersToHazardComponent } from '../assign-users-to-hazard/assign-users-to-hazard.component';

declare var $: any;

@Component({
    selector: 'app-submitted-form-list',
    templateUrl: './submitted-form-list.component.html',
    styleUrls: ['./submitted-form-list.component.scss']
})
export class SubmittedFormListComponent implements OnInit {
    submittedForms: any = [];
    pageNumber: number = 0;
    searchString = '';
    isFromScroll = false;
    formType = 'inspection';
    showFilters: boolean;
    filtersViewData = [];
    filtersViewList = [];
    dropdownSettings = {};
    currentPage: string;
    emptyResultError: boolean;
    passwordValue: string = '';
    errMessage: String;
    displayPwd: Boolean;
    downloadType: String;
    inspectionID = '5bd065f36b7e701fb4894bd3';
    selectedFiltersList: undefined;
    public taskObjs = [];
    workOrderId: string;
    voltasBetweenDates: any;
    errorMessage = '';
    taskId;
    @ViewChild('inputFiles') myInputVariable: ElementRef;
    optedOperators = []
    isHavingReviewData = false;
    reviewDataOptions = [];
    usersList: Array<any> = [];
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _submittedFormListService: SubmittedFormListService,
        private _router: Router,
        private modalService: NgbModal,
        private _capabilityEngineService: CapabilityEngineService,
        private _submittedFormPreviewService: SubmittedFormPreviewService,
        private _location: Location,
        private _filtersService: SubmittedFormFilterService
    ) { }
    checkDisplayFieldValue(data) {
        if (data) {
            return data[this._activatedRoute.snapshot.queryParams['key']]
        }
    };
    displayName() {
        return this._activatedRoute.snapshot.queryParams['display'];
    }

    getFormType(type) {

        if (type === this.formType) {
            return true;
        }
        return false;
    }

    getFormReportType() {
        if ((this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:equiputil')
            || (this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:gevera:equiputil')) {
            return 'AVAILABILITY'
        } else if ((this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:actionreport')
            || (this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:gevera:actionreport')) {
            return 'ACTION_REPORT'
        } else if ((this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:sarada:equiputil') || (this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:sarada:eqpmeasurepoint')) {
            return 'BARBIL_PERFORMANCE_REPORT'
        } else if (this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:hzl:equiputil') {
            return 'AGUCHA_PERFORMANCE_REPORT'
        } else if (this._activatedRoute.snapshot.params['id'] === 'fh_task_template:voltas:tata:equiputil') {
            return 'BOKARO_PERFORMANCE_REPORT'
        } else {
            return 'REGULAR'
        }
    }
    ngOnInit() {
        this.displayName();
        localStorage.removeItem('submittedFormIds');

        this.formType = this._activatedRoute.snapshot.queryParams.formType ? this._activatedRoute.snapshot.queryParams.formType : 'inspection';
        if (this.formType == 'hazard') {
            this.currentPage = 'hazards';
        }

        if (this.formType == 'action') {
            this.currentPage = 'actions';
        }

        this._filtersService.getInitialDataForSubmittedFilter().subscribe((response: any) => {
            if(response && response['data'] && response['data']['usersList'] && response['data']['usersList'].length) {
                this.usersList = response['data']['usersList'];
            }
        })

        this._activatedRoute.queryParams.subscribe(queryParams => {

            let queryParamsList = _.cloneDeep(
                this._activatedRoute.snapshot.queryParams
            );
            this.pageNumber = 0;
            this.submittedForms = [];

            if (queryParamsList.filter && queryParamsList.filter === 'true') {
                this.showFilters = true;
                this.dropdownSettings = {
                    singleSelection: false,
                    idField: '_id',
                    textField: 'name',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    // itemsShowLimit: 3,
                    enableCheckAll: false,
                    allowSearchFilter: true,
                    disabled: true
                };
                // this.filtersViewList = [{ _id: 'submitted', name: 'Submitted', data: '&status=submitted' }];
                this.getFilteredTasks(queryParamsList);
                // this.previewFiltersListUI(queryParamsList);
            } else {
                this.showFilters = false;
                this.getTasks();
                this.formName();
            }
        });
    }
    formName() {
        return this._activatedRoute.snapshot.queryParams['formName'];
    }
    isAcitve() {
        return this._activatedRoute.snapshot.queryParams['isActive'] ? false : true;
    }
    searchTasks(searchString) {
        this.pageNumber = 0;
        this.submittedForms = [];

        this.isFromScroll = false;
        this.searchString = searchString;

        if (this.searchString.length === 0) {
            // Search string is empty
            this.getTasks();
        } else {
            this.getTasksWithSearchString();
        }
    }

    onScroll() {
        this.isFromScroll = true;

        let queryParamsList = _.cloneDeep(
            this._activatedRoute.snapshot.queryParams
        );
        if (queryParamsList.filter && queryParamsList.filter === 'true') {

            this.getFilteredTasks(queryParamsList)

        } else if (this.searchString.length === 0) {
            // Search string is empty
            this.getTasks();
        } else {
            this.getTasksWithSearchString();
        }
    }
    checkReviewName(status, updatedBy, reviewedBy) {
        let name: string;
        if (reviewedBy && reviewedBy.name) {
            if (status !== 1) {
                name = reviewedBy.name
            }
        } else if (updatedBy && updatedBy.name && status !== 1) {
            name = updatedBy.name;
        } else {
            name = '--';
        }
        return name;
    }

    isFormhound() {
        return this._capabilityEngineService.isFormhound();
    }

    isOshaMshaForm() {
        return this._capabilityEngineService.isOshaMshaForm();
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    getTasks() {
        const templateId = this._activatedRoute.snapshot.params['id'];
        const displayFieldKey = this._activatedRoute.snapshot.queryParams['key'];
        this._submittedFormListService
            .performPagination(templateId, this.pageNumber, this.formType, displayFieldKey)
            .subscribe((result: any) => {
                console.log(
                    'TCL: SubmittedFormListComponent -> getTasks -> result',
                    result
                );
                if (!this.submittedForms) {
                    this.submittedForms = result.data;
                } else {
                    this.submittedForms = _.union(
                        this.submittedForms,
                        result.data
                    );
                }
                if (result.reviewTemplate && result.reviewTemplate.length > 0) {
                    let tempReviewTemplate = result.reviewTemplate[0];
                    let tempReviewOptions = [];

                    // Getting review data options
                    this.reviewDataOptions = tempReviewTemplate.rFFSchema.schema.review_form_form[0].review_form_form_new_page0[0].review_form_form_new_page0_section0[0].review_form_form_new_page0_section0_rating0.data;
                    _.forEach(this.reviewDataOptions, (option) => {
                        let obj = {
                            _id: Object.keys(option)[0].toString(),
                            name: option[Object.keys(option)[0].toString()]
                        }
                        tempReviewOptions.push(obj);
                    })
                    this.reviewDataOptions = [...tempReviewOptions];

                    for (let form of this.submittedForms) {
                        if (form.reviewData && form.reviewData.data.review_form_form_new_page0_section0_rating0) {
                            this.isHavingReviewData = true;
                            form.rating = this.reviewDataOptions && this.reviewDataOptions.length > 0 ? this.reviewDataOptions.length - parseInt(Object.keys(form.reviewData.data.review_form_form_new_page0_section0_rating0).toString()) : 0
                        }
                    }
                }
                var submittedFormIds = {};
                submittedFormIds[templateId] = _.map(this.submittedForms, '_id');
                localStorage.setItem('submittedFormIds', JSON.stringify(submittedFormIds));

                this.pageNumber++;
                if (this.submittedForms.length === 0) {
                    this.emptyResultError = false;
                }
                // console.log('submitted forms');
                // console.log(this.submittedForms);
                _.each(this.submittedForms, function (form) {
                    form.isFormSelected = false;
                });
                // console.log('submitted forms after checkbox added');
                // console.log(this.submittedForms);
            });
    }
    getFilteredTasks(queryParamsList: any) {
        let dataObj: any = {};
        dataObj.templateId = this._activatedRoute.snapshot.params['id'];
        dataObj.formType = this.formType;
        // if (queryParamsList.wid) {
        //     dataObj.workAreasList = queryParamsList.wid;
        // }
        
        if (queryParamsList.uid) {
            dataObj.usersList = queryParamsList.uid;
        }
        // TODO: Convert status number to int and then send

        if (queryParamsList.status) {
            dataObj.status = queryParamsList.status;
        }

        if (queryParamsList.containsHazards) {
            dataObj.containsHazards = queryParamsList.containsHazards;
        }

        if (queryParamsList.submittedFrom && queryParamsList.submittedTo) {
            dataObj.submittedDateRange = [
                queryParamsList.submittedFrom,
                queryParamsList.submittedTo
            ];
        }

        if (queryParamsList.reviewedFrom && queryParamsList.reviewedTo) {
            dataObj.reviewedDateRange = [
                queryParamsList.reviewedFrom,
                queryParamsList.reviewedTo
            ];
        }

        if (queryParamsList.reportedFrom && queryParamsList.reportedTo) {
            dataObj.reportedDateRange = [
                queryParamsList.reportedFrom,
                queryParamsList.reportedTo
            ];
        }

        if (queryParamsList.FixedFrom && queryParamsList.FixedTo) {
            dataObj.fixedDateRange = [
                queryParamsList.FixedFrom,
                queryParamsList.FixedTo
            ];
        }
        if (queryParamsList.reviewFeedBack) {
            dataObj.reviewFeedBack = queryParamsList.reviewFeedBack;
        }

        this._submittedFormListService
            .getFilteredTasks(dataObj, this.pageNumber)
            .subscribe((result: any) => {
                if (!this.submittedForms) {
                    this.submittedForms = result.data;
                } else {
                    this.submittedForms = _.union(
                        this.submittedForms,
                        result.data
                    );
                }
                let reviewTemplate = result.reviewTemplate && result.reviewTemplate[0] ? result.reviewTemplate[0] : {}

                if (!_.isEmpty(reviewTemplate)) {
                    let tempReviewOptions = [];

                    // Getting review data options
                    this.reviewDataOptions = reviewTemplate.rFFSchema.schema.review_form_form[0].review_form_form_new_page0[0].review_form_form_new_page0_section0[0].review_form_form_new_page0_section0_rating0.data;
                    _.forEach(this.reviewDataOptions, (option) => {
                        let obj = {
                            _id: Object.keys(option)[0].toString(),
                            name: option[Object.keys(option)[0].toString()]
                        }
                        tempReviewOptions.push(obj);
                    })
                    this.reviewDataOptions = [...tempReviewOptions];

                    for (let form of this.submittedForms) {
                        if (form.reviewData && form.reviewData.data.review_form_form_new_page0_section0_rating0) {
                            this.isHavingReviewData = true;
                            form.rating = this.reviewDataOptions.length > 0 && form.reviewData && form.reviewData.data.review_form_form_new_page0_section0_rating0 ? this.reviewDataOptions.length - parseInt(Object.keys(form.reviewData.data.review_form_form_new_page0_section0_rating0).toString()) : 0
                        }
                    }
                }
                var submittedFormIds = {};
                submittedFormIds[dataObj.templateId] = _.map(this.submittedForms, '_id');
                localStorage.setItem('submittedFormIds', JSON.stringify(submittedFormIds));
                this.pageNumber++;
                if (this.submittedForms.length === 0) {
                    this.emptyResultError = false;
                }
                _.each(this.submittedForms, function (form) {
                    form.isFormSelected = false;
                });
                this.previewFiltersListUI(queryParamsList);
            });
    }

    previewFiltersListUI(queryParamsList: any) {
        this.filtersViewData = [];
        this.filtersViewList = [];
        if (queryParamsList.wid) {
            queryParamsList.wid = !_.isArray(queryParamsList.wid)
                ? [queryParamsList.wid]
                : queryParamsList.wid;
            _.forEach(queryParamsList.wid, _w => {
                if (queryParamsList[_w]) {
                    this.filtersViewData.push({
                        _id: _w,
                        name: queryParamsList[_w],
                        data:
                            '&wid=' +
                            _w +
                            '&' +
                            _w +
                            '=' +
                            encodeURI(queryParamsList[_w])
                    });
                }
            });
        }

        if (queryParamsList.uid) {
            queryParamsList.uid = !_.isArray(queryParamsList.uid)
                ? [queryParamsList.uid]
                : queryParamsList.uid;
            _.forEach(queryParamsList.uid, _u => {
                if (queryParamsList[_u]) {
                    this.filtersViewData.push({
                        _id: _u,
                        name: queryParamsList[_u],
                        data:
                            '&uid=' +
                            _u +
                            '&' +
                            _u +
                            '=' +
                            encodeURI(queryParamsList[_u])
                    });
                }
            });
        }

        if (queryParamsList.status) {
            queryParamsList.status = !_.isArray(queryParamsList.status)
                ? [queryParamsList.status]
                : queryParamsList.status;
            _.forEach(queryParamsList.status, _status => {
                switch (_status) {
                    case 'submitted':
                        this.filtersViewData.push({
                            _id: 'submitted',
                            name: 'Submitted',
                            data: '&status=submitted'
                        });
                        break;
                    case 'reviewed':
                        this.filtersViewData.push({
                            _id: 'reviewed',
                            name: 'Reviewed',
                            data: '&status=reviewed'
                        });
                        break;
                    case 'active':
                        this.filtersViewData.push({
                            _id: 'active',
                            name: this.formType == 'action' ? 'Active Actions' : 'Active Hazards',
                            data: '&status=active'
                        });
                        break;
                    case 'fixed':
                        this.filtersViewData.push({
                            _id: 'fixed',
                            name: this.formType == 'action' ? 'Fixed Actions' : 'Fixed Hazards',
                            data: '&status=fixed'
                        });
                        break;
                    default:
                        alert('Status not available.');
                }
            });
        }

        if (queryParamsList.containsHazards) {
            if (queryParamsList.containsHazards === 'true') {
                this.filtersViewData.push({
                    _id: 'containsHazards',
                    name: 'Contains Hazards',
                    data: '&containsHazards=true'
                });
            } else if (queryParamsList.containsHazards === 'false') {
                this.filtersViewData.push({
                    _id: 'containsNoHazards',
                    name: 'No Hazards',
                    data: '&containsHazards=false'
                });
            }
        }
        // // SubmittedAt: 21stJul,2018to26thNov,2018
        if (queryParamsList.submittedFrom && queryParamsList.submittedTo) {
            this.filtersViewData.push({
                _id: 'SubmittedAt',
                name: this.getFormattedDateForPreview(
                    'SubmittedAt: ',
                    queryParamsList.submittedFrom,
                    queryParamsList.submittedTo
                ),
                data:
                    '&submittedFrom=' +
                    queryParamsList.submittedFrom +
                    '&submittedTo=' +
                    queryParamsList.submittedTo
            });
        }

        if (queryParamsList.reviewedFrom && queryParamsList.reviewedTo) {
            this.filtersViewData.push({
                _id: 'ReviewedAt',
                name: this.getFormattedDateForPreview(
                    'ReviewedAt: ',
                    queryParamsList.reviewedFrom,
                    queryParamsList.reviewedTo
                ),
                data:
                    '&reviewedFrom=' +
                    queryParamsList.reviewedFrom +
                    '&reviewedTo=' +
                    queryParamsList.reviewedTo
            });
        }

        if (queryParamsList.reportedFrom && queryParamsList.reportedTo) {
            this.filtersViewData.push({
                _id: 'ReportedAt',
                name: this.getFormattedDateForPreview(
                    'ReportedAt: ',
                    queryParamsList.reportedFrom,
                    queryParamsList.reportedTo
                ),
                data:
                    '&reportedFrom=' +
                    queryParamsList.reportedFrom +
                    '&reportedTo=' +
                    queryParamsList.reportedTo
            });
        }

        if (queryParamsList.FixedFrom && queryParamsList.FixedTo) {
            this.filtersViewData.push({
                _id: 'FixedAt',
                name: this.getFormattedDateForPreview(
                    'FixedAt: ',
                    queryParamsList.FixedFrom,
                    queryParamsList.FixedTo
                ),
                data:
                    '&FixedFrom=' +
                    queryParamsList.FixedFrom +
                    '&FixedTo=' +
                    queryParamsList.FixedTo
            });
        }

        if (queryParamsList.reviewFeedBack && queryParamsList.reviewFeedBack.length > 0) {
            let slectedReviewFeedBack = _.isArray(queryParamsList.reviewFeedBack) ? queryParamsList.reviewFeedBack : [queryParamsList.reviewFeedBack];
            _.forEach(slectedReviewFeedBack, _reviewFeedBack => {
                let obj = {};
                obj['_id'] = _reviewFeedBack;
                obj['name'] = _reviewFeedBack
                let selecetedReviewOption = _.find(this.reviewDataOptions, (option) => {
                    if (option._id === _reviewFeedBack) {
                        return option
                    };
                });
                obj['name'] = selecetedReviewOption ? selecetedReviewOption['name'] : '-';
                obj['data'] = '&reviewFeedBack=' + _reviewFeedBack;
                this.filtersViewData.push(obj);
            })
        }

        /* Now that all the view data has been created, this will be used later to call the API
        whenever a change to the filters has been made. */

        // Creating filtersViewList for populating the UI
        _.forEach(this.filtersViewData, data => {
            this.filtersViewList.push(_.pick(data, ['_id', 'name']));
        });

        if (_.isEmpty(this.filtersViewList)) {
            this.showFilters = false;
        }
    }

    getFormattedDateForPreview(title, fromDate, toDate) {
        return (
            title +
            moment(fromDate).format('MMM Do, YYYY') +
            ' to ' +
            moment(toDate).format('MMM Do, YYYY')
        );
    }

    onDeSelect(items: any) {
        let innerFiltersViewData = _.cloneDeep(this.filtersViewData);
        _.forEach(this.filtersViewData, function (n) {
            switch (items._id) {
                case 'submitted':
                    _.remove(innerFiltersViewData, (m: any) => {
                        return m._id === 'SubmittedAt' || m._id === 'submitted';
                    });
                    break;
                case 'reviewed':
                    _.remove(innerFiltersViewData, (m: any) => {
                        return m._id === 'ReviewedAt' || m._id === 'reviewed';
                    });
                    break;
                case 'active':
                    _.remove(innerFiltersViewData, (m: any) => {
                        return m._id === 'ReportedAt' || m._id === 'active';
                    });
                    break;
                case 'fixed':
                    _.remove(innerFiltersViewData, (m: any) => {
                        return m._id === 'FixedAt' || m._id === 'fixed';
                    });
                    break;
                default:
                    _.remove(innerFiltersViewData, (m: any) => {
                        return m._id === items._id;
                    });
            }
        });
        this.filtersViewData = innerFiltersViewData;

        let queryParams = this._activatedRoute.snapshot.queryParams;
        let newUrl = '';
        if (!_.isEmpty(this.filtersViewData)) {
            if (this.getFormType('hazard')) {
                newUrl =
                    '/hazards/' +
                    this._activatedRoute.snapshot.params['id'] +
                    '?formType=' + this.formType + '&filter=true';
            } else if (this.getFormType('action')) {
                newUrl =
                    '/actions/' +
                    this._activatedRoute.snapshot.params['id'] +
                    '?formType=' + this.formType + '&filter=true';
            } else {
                if (queryParams.display) {
                    newUrl = this.queryparamsUrl(queryParams) + '&filter=true';
                } else {
                    newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['id'] + '?filter=true';
                }
            }
            _.forEach(this.filtersViewData, item => {
                newUrl = newUrl.concat(item.data);
            });
            console.log('if data is there', newUrl)
        } else {
            if (this.getFormType('hazard')) {
                newUrl =
                    '/hazards/' +
                    this._activatedRoute.snapshot.params['id'] +
                    '?formType=' + this.formType + '&filter=false';
            } else if(this.getFormType('action')) {
                newUrl =
                    '/actions/' +
                    this._activatedRoute.snapshot.params['id'] +
                    '?formType=' + this.formType + '&filter=false';
            } else {
                if (queryParams.display) {
                    newUrl = this.queryparamsUrl(queryParams) + '&filter=' + false;
                } else {
                    newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['id'] + '?filter=false';
                }
            }
            console.log('if data is not there', newUrl)
        }
        this._router.navigateByUrl(newUrl);
    }
    queryparamsUrl(queryParams) {
        return '/submittedFormList/' + this._activatedRoute.snapshot.params['id'] + '?formName=' + queryParams.formName + '&key=' + queryParams.key + '&display=' + queryParams.display;
    }
    clearFilters() {
        let queryParams = this._activatedRoute.snapshot.queryParams;
        let newUrl = '';
        if (this.getFormType('hazard')) {
            newUrl = '/hazards/' + this._activatedRoute.snapshot.params['id'] + '?formType=hazard';
        } else if (this.getFormType('action')) {
            newUrl = '/actions/' + this._activatedRoute.snapshot.params['id'] + '?formType=action';
        } else {
            if (queryParams.display) {
                newUrl = this.queryparamsUrl(queryParams);
            } else {
                newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['id'] + "?filter=false";
            }
        }
        this._router.navigateByUrl(newUrl);
    }

    getTasksWithSearchString() {
        const templateId = this._activatedRoute.snapshot.params['id'];
        // Search tasks using search string
        this._submittedFormListService
            .getTasksOnSearch(
                this.searchString,
                templateId,
                this.pageNumber,
                this.getFormType('hazard')
            )
            .subscribe(
                (result: any) => {
                    if (this.isFromScroll) {
                        this.submittedForms = _.union(
                            this.submittedForms,
                            result.data
                        );
                    } else {
                        this.submittedForms = result.data;
                    }
                    this.pageNumber++;
                },
                err => {
                    // console.log('Search tasks Error :  ', err)
                }
            );
        if (this.submittedForms.length === 0) {
            this.emptyResultError = true;
        }
    }

    downloadmultiplecsv() {
        let csvIds = [];
        _.forEach(this.taskObjs, task => {
            csvIds.push(task._id);
        });
        // console.log(csvIds, 'ids for csv');
        let dataObj = {
            ids: csvIds,
            downloadType: 'CSV'
        };

        const templateId = this._activatedRoute.snapshot.params['id'];
        if (templateId === '5da944a49e6002772ba9bbcc' || templateId === 'fh_template_preview:workplaceinspection') {
            this._submittedFormListService
                .downloadLHoistCSV(dataObj)
                .subscribe((data: any) => {
                    let folderName = '';
                    folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                    const blob = new Blob([data], {
                        type: 'application/xlsx'//'application/zip;charset=utf-8'
                    });
                    saveAs(blob, `${folderName}.xlsx`);
                });
            return;
        }

        this._submittedFormListService
            .downloadMultipleCSV(dataObj)
            .subscribe((data: any) => {
                let folderName = '';
                folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], {
                    type: 'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.zip`);
            });
    }
    toggleModal(_downloadType: String) {
        this.downloadType = _downloadType;
    }
    closeDownloadErrorModal() {
        $('#downloadErrorModal').modal('toggle');
    }
    downloadmultiplenewpdf() {
        if (this.taskObjs.length > 5) {
            this.closeDownloadErrorModal();
            return;
        }
        let dataObj = [];
        _.forEach(this.taskObjs, task => {
            if (this.getFormType('hazard')) {
                let obj = {
                    _id: task._id,
                    taskId: task.taskId,
                    downloadType: this.downloadType,
                    workOrderId: task.workOrderId,
                    inspectionId: task.inspectionId,
                };
                dataObj.push(obj);
            } else {
                let obj = {
                    _id: task._id,
                    taskId: task.taskId,
                    downloadType: this.downloadType,
                    workOrderId: task.workOrderId,
                    inspectionId: task.inspectionID,
                };
                dataObj.push(obj);
            }
        });
        this._submittedFormListService
            .downloadMultiplePdf(dataObj)
            .subscribe((data: any) => {
                let folderName = '';
                folderName =
                    (environment.APP_NAME || '') +
                    ' PDF ' +
                    moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], {
                    type: 'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.zip`);
            });
    }

    checkBoxClick(task, event) {

        if (event.target.checked === true) {
            const index = this.taskObjs.indexOf(task);
            if (index === -1) {
                this.taskObjs.push(task);
            }
        } else {
            const index = this.taskObjs.indexOf(task);

            if (index !== -1) {
                this.taskObjs.splice(index, 1);
            }

        }
        // console.log(this.taskObjs.length);
        if (this.taskObjs.length < this.submittedForms.length) {
            $('#checkbox-style-div-2').prop('checked', false);
        } else {
            $('#checkbox-style-div-2').prop('checked', true);
        }

        event.stopPropagation();


    }
    fixHazardform(taskId) {
        this._router.navigateByUrl(
            '/hazardform/' + taskId + '?currentPage=hazards&formType=' + this.formType
        );
    }

    fixAction(taskId) {
        this._router.navigateByUrl(
            '/form/' + taskId + '?currentPage=actions&formType=' + this.formType
        );
    }
    navigateToPreview(taskId, event) {

        let formType = 'inspection';
        if (this.getFormType('hazard')) {
            formType = 'hazard';
        } if (this.getFormType('action')) {
            formType = 'action';
        }
        this._router.navigateByUrl('/submittedFormPreview/' + taskId + '?formType=' + formType);
    }
    navigateInspection() {
        this._router.navigateByUrl('/formFilling/' + this._activatedRoute.snapshot.params['id'] + '?formType=inspection');
    }

    navigateToHazardForm() {
        this._router.navigateByUrl('/formFilling/' + this._activatedRoute.snapshot.params['id'] + '?formType=hazard');
    }

    navigateToActionForm() {
        this._router.navigateByUrl('/formFilling/' + this._activatedRoute.snapshot.params['id'] + '?formType=action');
    }

    selectAllForms(event) {
        let context = this;
        if (event.target.checked === true) {
            _.each(this.submittedForms, function (form: any) {
                form.isFormSelected = true;
                // console.log(form._id);
                const index = context.taskObjs.indexOf(form);
                if (index === -1) {
                    context.taskObjs.push(form);
                }
            });
        } else {
            _.each(this.submittedForms, function (form: any) {
                form.isFormSelected = false;
                const index = context.taskObjs.indexOf(form);

                if (index !== -1) {
                    context.taskObjs.splice(index, 1);
                }
            });
        }

        if (this.taskObjs.length < this.submittedForms.length) {
            $('#checkbox-style-div-2').prop('checked', false);
        } else {
            $('#checkbox-style-div-2').prop('checked', true);
        }
        console.log(context.taskObjs.length);
    }

    submittedformsfilter() {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'inspection-filter'
        };

        let dataObj: any = {};
        let queryParams = _.cloneDeep(
            this._activatedRoute.snapshot.queryParams
        );
        if (this.getFormType('hazard') == false && queryParams['filter'] == undefined && (localStorage.getItem("userRole") == "supervisor" || localStorage.getItem("userRole") == "webAdmin") && this.optedOperators && this.optedOperators.length > 0 && !queryParams.uid) {
            queryParams['uid'] = this.optedOperators
        }

        // if (queryParams.wid) {
        //     dataObj.wid = [];
        //     queryParams.wid = !_.isArray(queryParams.wid)
        //         ? [queryParams.wid]
        //         : queryParams.wid;
        //     _.forEach(queryParams.wid, _workAreaId => {
        //         if (queryParams[_workAreaId]) {
        //             dataObj.wid.push({
        //                 _id: _workAreaId,
        //                 name: queryParams[_workAreaId]
        //             });
        //         }
        //     });
        //     queryParams.wid = dataObj.wid;
        // }

        if (queryParams.uid && queryParams['filter'] == 'true') {
            dataObj.uid = [];
            queryParams.uid = !_.isArray(queryParams.uid)
                ? [queryParams.uid]
                : queryParams.uid;
            _.forEach(queryParams.uid, _userId => {
                if (queryParams[_userId]) {
                    dataObj.uid.push({
                        _id: _userId,
                        name: queryParams[_userId]
                    });
                }
            });
            queryParams.uid = dataObj.uid;
        }

        if (queryParams.status) {
            dataObj.status = [];
            queryParams.status = !_.isArray(queryParams.status)
                ? [queryParams.status]
                : queryParams.status;
            if (_.includes(queryParams.status, 'submitted')) {
                dataObj.status.push({ _id: 'submitted', name: 'Submitted' });
            }
            if (_.includes(queryParams.status, 'reviewed')) {
                dataObj.status.push({ _id: 'reviewed', name: 'Reviewed' });
            }
            queryParams.status = dataObj.status;
        }

        if (queryParams.reviewFeedBack && queryParams.reviewFeedBack.length > 0) {
            let slectedReviewFeedBack = _.isArray(queryParams.reviewFeedBack) ? queryParams.reviewFeedBack : [queryParams.reviewFeedBack];
            dataObj.reviewFeedBack = [];
            _.forEach(slectedReviewFeedBack, _reviewFeedBack => {
                let obj = {};
                obj['_id'] = _reviewFeedBack;
                obj['name'] = _reviewFeedBack
                let selecetedReviewOption = _.find(this.reviewDataOptions, (option) => {
                    if (option._id === _reviewFeedBack) {
                        return option
                    };
                });
                obj['name'] = selecetedReviewOption ? selecetedReviewOption['name'] : '-';
                obj['data'] = '&reviewFeedBack=' + _reviewFeedBack;
                dataObj.reviewFeedBack.push(obj);
            })
            queryParams.reviewFeedBack = dataObj.reviewFeedBack;
        }

        const modalRef = this.modalService.open(
            SubmittedFormListFilterComponent,
            modalOptions
        );
        modalRef.componentInstance.parentComponentData = {
            templateId: this._activatedRoute.snapshot.params['id'],
            queryParams: queryParams,
            reviewOptions: this.reviewDataOptions
        };
        modalRef.result.then(
            res => {
                console.log('confirmed for changes');
            },
            () => {
                console.log('not confirmed for changes');
            }
        );
    }

    hazardfilter(isVoltas, type, reportType, isDyno?) {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'hazard-filter'
        };

        let dataObj: any = {};
        let queryParams = _.cloneDeep(
            this._activatedRoute.snapshot.queryParams
        );

        // if (queryParams.wid) {
        //     dataObj.wid = [];
        //     queryParams.wid = !_.isArray(queryParams.wid)
        //         ? [queryParams.wid]
        //         : queryParams.wid;
        //     _.forEach(queryParams.wid, _workAreaId => {
        //         if (queryParams[_workAreaId]) {
        //             dataObj.wid.push({
        //                 _id: _workAreaId,
        //                 name: queryParams[_workAreaId]
        //             });
        //         }
        //     });
        //     queryParams.wid = dataObj.wid;
        // }

        if (queryParams.status) {
            dataObj.status = [];
            queryParams.status = !_.isArray(queryParams.status)
                ? [queryParams.status]
                : queryParams.status;
            if (_.includes(queryParams.status, 'active')) {
                dataObj.status.push({ _id: 'active', name: `${ this.formType == 'action' ? 'Active Actions' : 'Active Hazards'}` });
            }
            if (_.includes(queryParams.status, 'fixed')) {
                dataObj.status.push({ _id: 'fixed', name: `${ this.formType == 'action' ? 'Fixed Actions' : 'Fixed Hazards'}` });
            }
            queryParams.status = dataObj.status;
        }
        if (isVoltas) queryParams = { filter: 'Voltas', formName: this.formName(), type: type, reportType: reportType }
        if (!isVoltas && isDyno) {
            queryParams = {
                filter: 'dyno',
                formName: this.formName(),
                type: type,
                reportType: reportType
            }
        }
        const modalRef = this.modalService.open(
            HazardFormListFilterComponent,
            modalOptions
        );
        modalRef.componentInstance.parentComponentData = {
            templateId: this._activatedRoute.snapshot.params['id'],
            queryParams: queryParams,
            formType: this.formType
        };
        modalRef.result.then(
            res => {
                console.log('confirmed for changes');
            },
            () => {
                console.log('not confirmed for changes');
                console.log(this.filtersViewData);
            }
        );
    }

    // upload xlsx file
    onSelectFile(event) {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            if (file && file.size > 1000000) {
                $('#fileUploadModal').modal('show');
                this.errorMessage = 'Please upload .xlsx file less than 1mb';
                this.myInputVariable.nativeElement.value = '';
                return;
            }
            this.myInputVariable.nativeElement.value = '';
            this._submittedFormListService.uploadExcel(file, this._activatedRoute.snapshot.params['id']).toPromise().then(
                (res: any) => {
                    this.ngOnInit();
                }
            ).catch((err: any) => {
                $('#fileUploadModal').modal('show');
                this.errorMessage = err.error.message;
            });
        }
    }

    deleteForm(taskId, modal) {
        if (taskId) this.taskId = taskId;
        if (modal) $('#deleteModal').modal('show');
        else {
            let task = { id: this.taskId };
            console.log('delete form');
            this._submittedFormPreviewService.deleteForm(task)
                .subscribe((result: any) => {
                    this.ngOnInit();
                    console.log('deleted form');
                }, (err) => {
                    this.errorMessage = err.error.message;
                });
        }
    }
    generateActionReport(type) {
        this._submittedFormListService.downloadVoltasActionReportExcel({ type: type, tasks: this.taskObjs }).toPromise().then(
            (data: any) => {
                let folderName = '';
                folderName =
                    (environment.APP_NAME || '') +
                    ' SERVICE REPORT ' +
                    moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], {
                    type: 'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.zip`);
            }
        ).catch((err: any) => {
            $('#fileUploadModal').modal('show');
            this.errorMessage = err.error.message;
        });
    }
    generateFioreShiftReport(type?) {
        this._submittedFormListService.downloadVoltasFioreShiftReport({ type: type, tasks: this.taskObjs }).toPromise().then(
            (data: any) => {
                let folderName = '';
                folderName =
                    (environment.APP_NAME || '') +
                    ' FIORE SHIFT REPORT ' +
                    moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], {
                    type: 'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.zip`);
            }
        ).catch((err: any) => {
            $('#fileUploadModal').modal('show');
            this.errorMessage = err.error.message;
        });
    }

    getOperatorIDs() {
        let teams = JSON.parse(localStorage.getItem("teams"))
        let operators = [];
        if (teams && teams.length > 0) {
            let presentTeamId = localStorage.getItem("teamId")
            let presentTeamIndex = _.findIndex(teams, { teamDetails: { "_id": presentTeamId } })
            if (presentTeamIndex != -1) {
                let presentTeamOperators = teams[presentTeamIndex]['operators'];
                if (presentTeamOperators && presentTeamOperators.length > 0) {
                    operators = _.map(presentTeamOperators, (operator) => {
                        return {
                            _id: operator['_id'],
                            name: operator['name']
                        }
                    })
                }
            }
        }

        if (operators && operators.length > 0) {
            this.optedOperators = operators
        }
    }


    isDynoTeamHazard() {
        if (this.getFormType('hazard') == true && localStorage.getItem('teamId') == environment.DYNO_TEAM_ID) {
            return true
        }
        return false;
    }

    createArrayForRating(n) {
        if (n != undefined)
            return Array(n);
        return []
    }

    assignHazardForm(form: any, selectedUsers?: any): void {

        if(form.status !== 0 || !this.canPerform(['assignHazard'])) {
            return;
        }
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'lg-dialog-medium',
        };
        const modalRef = this.modalService.open(AssignUsersToHazardComponent, modalOptions)
        modalRef.componentInstance.formId = form._id;
        modalRef.componentInstance.description = form.workOrderId;
        modalRef.componentInstance.usersList = this.usersList;
        if(selectedUsers) {
            selectedUsers = _.map(selectedUsers, (value, key) => {
                return {
                    _id: key,
                    name: value
                }
            })
            modalRef.componentInstance.selectedUsers = selectedUsers;
        }

        modalRef.result.then((response) => {
            if (response.success === true) {
                form.hAssignedTo = response['usersList'];
            }
        })
    }

    objectValues(object: any) {
        return Object.values(object);
    }

    displayEmployeeNames(employees: any) {
        let employeeNames = '';
        employeeNames = _.map(employees, (employee) => { 
            return employee.name;
        }).join(', ');
        
        return employeeNames;
    }
}



// WEBPACK FOOTER //
// ./src/app/submitted-form-list/submitted-form-list.component.ts